<template>
  <div class="signature d-flex justify-content-end">
    <div
      v-if="!data && techMode"
      class="signature-placeholder d-flex align-items-center justify-content-center font-size-lg half-width"
      @click="handleClick"
    >
      {{ placeholder }}
    </div>
    <div
      v-else-if="data"
      class="d-flex align-items-center justify-content-end full-height half-width"
    >
      <div class="d-flex flex-column" text-right>
        <span>
          {{ approvalText }}
          {{ data.kind === "overridden" ? " Manually" : "" }}
        </span>
        <span>{{ signatureDate }}</span>
      </div>
      <img
        v-if="data.kind !== 'overridden'"
        :src="data.image_url"
        alt="Signature"
      />
    </div>
  </div>
</template>

<script lang="ts">
import date from "serviceshift-ui/shared/src/filters/date";
import EventBus from "serviceshift-ui/shared/src/lib/event_bus";

import { Signature } from "@/typings/signature";

export default {
  props: {
    data: {
      type: Object as () => Signature,
      default: null
    },
    placeholder: {
      type: String,
      default: "Sign Here"
    },
    type: {
      type: String,
      default: ""
    },
    approvalText: {
      type: String,
      default: "Approved"
    },
    eventId: {
      type: [Number, String],
      default: null
    },
    techMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    signatureDate() {
      return date(this.data.signature_time);
    }
  },
  methods: {
    handleClick() {
      EventBus.$emit("signature-click", this.eventId);
    }
  }
};
</script>

<style lang="scss" scoped>
.signature {
  padding: 5px 0;
  img {
    height: 90px;
  }
  .signature-placeholder {
    height: 100%;
    padding: 30px;
    color: var(--primary-color);
    border: 3px dashed var(--medium-color);
    margin: 0 5px;
    text-decoration: underline;
  }
}
.full-height {
  height: 100%;
}
.half-width {
  width: 50%;
}
</style>
